import { Injectable } from '@angular/core';
import { Http , Response} from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { Utils } from './../shared/utils';
import 'rxjs/add/operator/toPromise';


import { Documento } from './documento';

@Injectable()
export class DocumentoService {

  private documentoUrl = '/documento';

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
    private utils: Utils
  ) {

  }

  getDocumentos(params?: any): Promise<Documento[]> {

    return this.http.get(this.documentoUrl, {search: this.utils.buildParams(params)})
                .toPromise()
                .then(response => response.json().dados as Documento[])
                .catch((error) => this.handleError(error));
  }

  getDocumento(id: number): Promise<Documento>{
    let url: string  = this.documentoUrl + '/' + id;
    return this.http.get(url)
               .toPromise()
               .then(response => response.json().dados as Documento)
               .catch((error) => this.handleError(error));
  }

  saveDocumento(documento: Documento): Promise<Response>{
    let url: string = this.documentoUrl;

    if(documento.id !== undefined)
      url = url + '/' + documento.id;

    return this.http
               .post(url, this.utils.buildFormData(documento))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }


  deleteDocumento(documento: Documento): Promise<Response>{
    let url: string = this.documentoUrl + '/' + documento.id ;
    return this.http
               .delete(url)
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  copiarDocumento(id: number): Promise<Response>{
    let url: string = this.documentoUrl + '/copiar/' + id ;
    return this.http
               .get(url)
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }


  private handleSuccess(resp: any): Promise<any> {
    if(!Array.isArray(resp.msg))
      this.utils.flashMessage(resp.msg, 'success');
    else{
      for(let msg of resp.msg){
        this.utils.flashMessage(msg, 'success');
      }
    }
    return resp;
  }

  private handleError(error: any): Promise<any> {
     switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        //this._flashMessagesService.show("Ocorreu error no servidor, entre em contato com o administrador.", { cssClass: 'card alert-danger', timeout: 5000 });
        break;
      case 403:
        if(!Array.isArray(error.json().msg)){
          this.utils.flashMessage(error.json().msg, 'warning');
        }else{
          for(let msg of error.json().msg){
            this.utils.flashMessage(msg, 'warning');
          }
        }
        
        //this._flashMessagesService.show(error.json().msg, { cssClass: 'card alert-warning', timeout: 5000 });
        break;
      default:
      this.utils.flashMessage("Ocorreu um error, tente novamente mais tarde.", 'danger');
        //this._flashMessagesService.show("Ocorreu um error, tente novamente mais tarde.", { cssClass: 'card alert-danger', timeout: 5000 });
    }
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/documentos/documento.service.ts